import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import Modal from 'react-modal';
import baseURL from '../url';
import './Cart.css';
import whatsappIcon from '../../images/wpp.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faShoppingCart, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Link as Anchor } from "react-router-dom";
import moneda from '../moneda';
import Swal from 'sweetalert2';
import { ToastContainer, toast } from 'react-toastify';
import FeedbackModal from '../FeedbackModal/FeedbackModal';
import DOMPurify from 'dompurify';

const Cart = forwardRef((props, ref) => {
    const [cartItems, setCartItems] = useState([]);
    const [productos, setProductos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [modalIsOpen2, setModalIsOpen2] = useState(false);
    
    // Exponer método para abrir el cart desde el componente padre
    useImperativeHandle(ref, () => ({
        openCart: () => {
            setModalIsOpen(true);
        }
    }));
    const [isFocused, setIsFocused] = useState(false);
    const [noteText, setNoteText] = useState('');
    const [location, setLocation] = useState('');
    const [name, setName] = useState('');
    const [telefono, setTelefono] = useState('');
    const [direccion, setDireccion] = useState('');
    const [codigo, setCodigo] = useState('');
    const [contactos, setContactos] = useState([]);
    const [descuento, setDescuento] = useState(0);
    const [codigoValido, setCodigoValido] = useState(false);
    const [cuponAplicado, setCuponAplicado] = useState(null);
    const [productosElegibles, setProductosElegibles] = useState([]);
    const [validandoCupon, setValidandoCupon] = useState(false);
    const [totalPrice, setTotalPrice] = useState(0);
    const [paymentMethod, setPaymentMethod] = useState('efectivo');
    const [deliveryOption, setDeliveryOption] = useState('reserve');
    
    // Estados para medios de pago
    const [paymentMethods, setPaymentMethods] = useState([]);
    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
    const [paymentReference, setPaymentReference] = useState('');
    const [paymentProof, setPaymentProof] = useState(null);
    const [paymentProofPreview, setPaymentProofPreview] = useState(null);
    const [address, setAddress] = useState('');
    const [estadoAbierto, setEstadoAbierto] = useState(true);
    const [horarioHoy, setHorarioHoy] = useState(null);
    const [mesasDisponibles, setMesasDisponibles] = useState([]);
    const [mesaSeleccionada, setMesaSeleccionada] = useState('');
    const [configuracion, setConfiguracion] = useState({
        domicilio_activo: 1,
        retiro_activo: 1,
        mesa_activo: 1,
        reservas_activo: 1,
        evaluacion_activo: 1,
    });
    const [feedbackModalOpen, setFeedbackModalOpen] = useState(false);
    const [ultimoPedidoId, setUltimoPedidoId] = useState(null);
    const [pedidosEvaluados, setPedidosEvaluados] = useState([]);
    
    useEffect(() => {
        cargarContacto();
        verificarEstado();
        cargarMesasDisponibles();
        cargarConfiguracion();
        cargarMetodosPago();
    }, []);
    useEffect(() => {
        // Calcular el precio total al cargar el carrito o al actualizar los productos
        let totalPriceCalc = 0;
        cartItems.forEach(item => {
            let itemPrice = item.precio;
            // Sumar el precio de los adicionales
            if (Array.isArray(item.items)) {
                item.items.forEach(adicional => {
                    if (adicional.price) {
                        itemPrice += Number(adicional.price);
                    }
                });
            }
            if(item.total){
                totalPriceCalc += item.total;
            }else{
                totalPriceCalc += itemPrice * item.cantidad;
            }
        });
        setTotalPrice(totalPriceCalc);
    }, [cartItems]);

    const cargarContacto = () => {
        fetch(`${baseURL}/contactoGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setContactos(data.contacto.reverse()[0] || []);
            })
            .catch(error => console.error('Error al cargar contactos:', error));
    };

    const verificarEstado = () => {
        fetch(`${baseURL}/horariosCheck.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    setEstadoAbierto(data.abierto);
                    setHorarioHoy(data.horario);
                }
            })
            .catch(error => {
                console.error('Error al verificar estado:', error);
                setEstadoAbierto(true);
            });
    };

    const verificarEvaluacionPedido = async (idPedido) => {
        try {
            const response = await fetch(`${baseURL}/evaluacionCheck.php?idPedido=${idPedido}`);
            const data = await response.json();
            return data.evaluado;
        } catch (error) {
            console.error('Error al verificar evaluación:', error);
            return false;
        }
    };

    const cargarMesasDisponibles = () => {
        fetch(`${baseURL}/mesasGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                console.log('Mesas disponibles cargadas:', data); // Debug
                if (data.success && data.mesas) {
                    setMesasDisponibles(data.mesas);
                } else {
                    setMesasDisponibles([]);
                }
            })
            .catch(error => {
                console.error('Error al cargar mesas:', error);
                setMesasDisponibles([]);
            });
    };

    const cargarConfiguracion = () => {
        fetch(`${baseURL}/configGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    setConfiguracion(data.config);
                    // Establecer deliveryOption por defecto según configuración
                    if (!deliveryOption) {
                        // if (data.config.retiro_activo === 1) {
                        //     setDeliveryOption('pickup');
                        // } else if (data.config.mesa_activo === 1) {
                        //     setDeliveryOption('mesa');
                        // }
                    }
                }
            })
            .catch(error => console.error('Error al cargar configuración:', error));
    };

    const cargarMetodosPago = () => {
        fetch(`${baseURL}/paymentMethodsGet.php?only_active=1`)
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    setPaymentMethods(data.payment_methods || []);
                    // Seleccionar primer método por defecto
                    if (data.payment_methods.length > 0) {
                        setSelectedPaymentMethod(data.payment_methods[0]);
                    }
                }
            })
            .catch(error => console.error('Error al cargar métodos de pago:', error));
    };

    const handlePaymentProofChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            // Validar tamaño
            if (file.size > 5 * 1024 * 1024) {
                toast.error('El archivo es demasiado grande. Máximo 5MB');
                return;
            }
            setPaymentProof(file);
            
            // Crear preview si es imagen
            if (file.type.startsWith('image/')) {
                const reader = new FileReader();
                reader.onloadend = () => {
                    setPaymentProofPreview(reader.result);
                };
                reader.readAsDataURL(file);
            } else {
                setPaymentProofPreview(null);
            }
        }
    };

    useEffect(() => {
        cargarProductos();
    }, [isFocused]);

    useEffect(() => {
        const fetchCartItems = async () => {
            const cart = JSON.parse(localStorage.getItem('cart')) || [];
            console.log("cart",cart)
            const promises = cart.map(async (cartItem) => {
                const producto = productos.find(producto => producto.idProducto === cartItem.idProducto);
                return {
                    ...producto,
                    detalle: cartItem.detalle,
                    fecha_fin: cartItem.fecha_fin,
                    fecha_inicio: cartItem.fecha_inicio,
                    noches: cartItem.noches,
                    total: cartItem.total,
                    cantidad: cartItem.cantidad,
                    items: cartItem.items || cartItem.item || [],
                };
            });

            Promise.all(promises)
                .then((items) => {
                    setCartItems(items);
                    setLoading(false);
                })
                .catch((error) => {
                    console.error('Error al obtener detalles del carrito:', error);
                    setLoading(false);
                });
        };

        fetchCartItems();
    }, [productos, isFocused]);

    const cargarProductos = () => {
        fetch(`${baseURL}/productosGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setProductos(data.productos || []);
            })
            .catch(error => console.error('Error al cargar productos:', error));
    };

    const obtenerImagen = (item) => {
        return item.imagen1 || item.imagen2 || item.imagen3 || item.imagen4 || null;
    };

    const openModal = () => {
        setModalIsOpen(true);
        setIsFocused(true);
    };

    const closeModal = () => {
        setModalIsOpen(false);
        setIsFocused(false);
        setPaymentReference('');
        setPaymentProof(null);
        setPaymentProofPreview(null);
    };

    const openModal2 = () => {
        setModalIsOpen2(true);
        // Recargar mesas disponibles al abrir el modal
        cargarMesasDisponibles();
    };

    const closeModal2 = () => {
        setModalIsOpen2(false);
        // Limpiar selección de mesa
        setMesaSeleccionada('');
        setPaymentReference('');
        setPaymentProof(null);
        setPaymentProofPreview(null);
    };

    // Función para limpiar cupón
    const limpiarCupon = () => {
        setCodigo('');
        setCuponAplicado(null);
        setDescuento(0);
        setCodigoValido(false);
        setProductosElegibles([]);
    };
    
    // Función para revalidar cupón automáticamente cuando cambia el carrito
    const revalidarCuponSiAplicado = async (carritoActualizado) => {
        if (!codigoValido || !cuponAplicado) {
            return; // No hay cupón aplicado, no hacer nada
        }
        
        // Calcular nuevo total
        let nuevoTotal = 0;
        carritoActualizado.forEach(item => {
            let itemPrice = item.precio;
            if (Array.isArray(item.items)) {
                item.items.forEach(adicional => {
                    if (adicional.price) {
                        itemPrice += Number(adicional.price);
                    }
                });
            }
            nuevoTotal += itemPrice * item.cantidad;
        });
        
        // Si el carrito está vacío, limpiar cupón
        if (carritoActualizado.length === 0) {
            limpiarCupon();
            return;
        }
        
        try {
            const productosParaValidar = carritoActualizado.map(item => ({
                idProducto: item.idProducto,
                titulo: item.titulo,
                precio: item.precio,
                cantidad: item.cantidad,
                categoria: item.idCategoria
            }));
            
            const response = await fetch(`${baseURL}/codigosValidar.php`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    codigo: codigo.trim().toUpperCase(),
                    productos: productosParaValidar,
                    total: nuevoTotal
                })
            });
            
            const data = await response.json();
            
            if (data.success) {
                // Actualizar el descuento con el nuevo valor
                setCuponAplicado(data.cupon);
                setDescuento(data.montoDescuento);
                setProductosElegibles(data.productosElegibles);
            } else {
                // El cupón ya no es válido (por ejemplo, no cumple monto mínimo)
                limpiarCupon();
                Swal.fire({
                    icon: 'warning',
                    title: 'Cupón removido',
                    text: data.error || 'El cupón ya no es aplicable con el nuevo total del carrito',
                    timer: 3000,
                    showConfirmButton: false
                });
            }
        } catch (error) {
            console.error('Error al revalidar cupón:', error);
        }
    };

    const removeFromCart = (id) => {
        const updatedCart = cartItems.filter(item => item.idProducto !== id);
        setCartItems(updatedCart);
        localStorage.setItem('cart', JSON.stringify(updatedCart));
        
        // Revalidar cupón si está aplicado
        revalidarCuponSiAplicado(updatedCart);
    };

    const clearCart = () => {
        setCartItems([]);
        localStorage.removeItem('cart');
        
        // Limpiar cupón cuando se vacía el carrito
        if (codigoValido || cuponAplicado) {
            limpiarCupon();
        }
    };

    // Función para validar cupón
    const validarCupon = async () => {
        if (!codigo.trim()) {
            Swal.fire({
                icon: 'warning',
                title: 'Código requerido',
                text: 'Ingrese un código de cupón',
                timer: 2000,
                showConfirmButton: false
            });
            return;
        }
        
        if (cartItems.length === 0) {
            Swal.fire({
                icon: 'warning',
                title: 'Carrito vacío',
                text: 'El carrito está vacío',
                timer: 2000,
                showConfirmButton: false
            });
            return;
        }
        
        setValidandoCupon(true);
        
        try {
            // Preparar productos para enviar al servidor
            const productosParaValidar = cartItems.map(item => ({
                idProducto: item.idProducto,
                titulo: item.titulo,
                precio: item.precio,
                cantidad: item.cantidad,
                categoria: item.idCategoria
            }));
            
            const response = await fetch(`${baseURL}/codigosValidar.php`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    codigo: codigo.trim().toUpperCase(),
                    productos: productosParaValidar,
                    total: totalPrice
                })
            });
            
            const data = await response.json();
            
            if (data.success) {
                setCuponAplicado(data.cupon);
                setDescuento(data.montoDescuento);
                setCodigoValido(true);
                setProductosElegibles(data.productosElegibles);
                
                Swal.fire({
                    icon: 'success',
                    title: '¡Cupón aplicado!',
                    html: `<p>Descuento: <strong>${moneda} ${data.montoDescuento.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</strong></p>`,
                    timer: 2500,
                    showConfirmButton: false
                });
            } else {
                setCuponAplicado(null);
                setDescuento(0);
                setCodigoValido(false);
                setProductosElegibles([]);
                
                Swal.fire({
                    icon: 'error',
                    title: 'Cupón no válido',
                    text: data.error || 'El cupón no pudo ser aplicado',
                    timer: 3000,
                    showConfirmButton: false
                });
            }
        } catch (error) {
            console.error('Error al validar cupón:', error);
            
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Error al validar cupón. Intente nuevamente.',
                timer: 2500,
                showConfirmButton: false
            });
        } finally {
            setValidandoCupon(false);
        }
    };

    const handleWhatsappMessage = () => {
        let totalPrice = 0;
        cartItems.forEach(item => {
            if (esReserva(item)) {
                totalPrice += Number(item.total);
                return;
            }

            // Productos normales
            let itemPrice = item.precio;

            if (Array.isArray(item.items)) {
                item.items.forEach(adicional => {
                    if (adicional.price) {
                        itemPrice += Number(adicional.price);
                    }
                });
            }

            totalPrice += itemPrice * item.cantidad;
        });
        let totalPriceWithDiscount = totalPrice - descuento;
        if (totalPriceWithDiscount < 0) totalPriceWithDiscount = 0;

        const formattedTotalPrice =
            totalPriceWithDiscount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");

        const phoneNumber = `${contactos.telefono}`;

        // ----------------------------------------
        // 👉 DETALLE POR WHATSAPP (con reservas)
        // ----------------------------------------
        const cartDetails = cartItems.map((item) => {
            if (esReserva(item)) {
                const detalleDias = item.detalle
                    .map(d => {
                        const fecha = d.fecha.split("-").reverse().join("/");
                        const precio = d.precio.toLocaleString("es-AR");
                        const alta = d.alta ? " (Alta)" : "";
                        return `       - ${fecha}: ${moneda} ${precio}${alta}`;
                    })
                    .join("\n");

                return (
    `\n🏨 *Reserva*
           Entrada: ${item.fecha_inicio.split("-").reverse().join("/")}
           Salida: ${item.fecha_fin.split("-").reverse().join("/")}
           Noches: ${item.noches}
           Total: ${moneda} ${item.total.toLocaleString("es-AR")}
           Detalle por día:
    ${detalleDias}\n`
                );
            }

            // 🔵 PRODUCTOS NORMALES (código original)
            let itemPrice = item.precio;
            let adicionalesText = '';

            if (Array.isArray(item.items)) {
                adicionalesText = item.items.map(adicional => {
                    if (adicional.price && adicional.price > 0) {
                        itemPrice += Number(adicional.price);
                        return `${adicional.name} (+${moneda} ${adicional.price})`;
                    }
                    return adicional.name || adicional;
                }).join(', ');
            } else if (Array.isArray(item.item)) {
                adicionalesText = item.item.join(', ');
            }

            const precioTotal = itemPrice * item.cantidad;

            return (
    `\n🍽️ *${item.titulo}*
           Cantidad: ${item.cantidad}
           Adicionales: ${adicionalesText}
           Precio total: ${moneda} ${precioTotal.toLocaleString("es-AR")}`
            );
        });

        // ----------------------------------------
        // RESTO DEL CÓDIGO (igual que tenías)
        // ----------------------------------------

        let noteMessage = '';

        if (location.trim() !== '') noteMessage += `\n📍 Ubicación: ${location}`;
        if (name.trim() !== '') noteMessage += `\n👤 Nombre: ${name}`;
        if (telefono.trim() !== '') noteMessage += `\n📞 Teléfono: ${telefono}`;
        if (noteText.trim() !== '') noteMessage += `\n📝 Nota: ${noteText}`;

        if (codigo.trim() !== '' && codigoValido && descuento > 0) {
            noteMessage += 
    `\n🏷️ Cupón: ${codigo}
    💸 Descuento: ${moneda} ${descuento.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`;
        }

        // Dirección / localización
        let entrega = '';
        if (deliveryOption === 'mesa') {
            const mesa = mesasDisponibles.find(m => m.idMesa === parseInt(mesaSeleccionada));
            entrega = `Comer en la acomodación - Acomodación ${mesa ? mesa.numero : mesaSeleccionada}`;
        } else if (deliveryOption === 'reserve') {
            entrega = `Reserva en Acomodación`;
        } else {
            const mesa = mesasDisponibles.find(m => m.idMesa === parseInt(mesaSeleccionada));
            entrega = `Retiro personalmente - Acomodación ${mesa ? mesa.numero : mesaSeleccionada}`;
        }

        // Método de pago
        const paymentMessage = selectedPaymentMethod?.name || 'Pago en efectivo';
        let paymentMessageComplete = `Forma de pago: ${paymentMessage}`;
        
        if (paymentReference?.trim()) {
            paymentMessageComplete += `\nReferencia: ${paymentReference}`;
        }

        const message =
    `¡Hola! 🌟 Mi Pedido es:
    ${cartDetails.join('')}
    ------------------------------------>
    ${noteMessage}

    ✅ ${entrega}
    ✅ ${paymentMessageComplete}

    ------------------------------------>

    *Total: ${moneda} ${formattedTotalPrice}*`;

        const whatsappUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`;

        window.open(whatsappUrl, '_blank');

        setName('');
        setLocation('');
        setNoteText('');
        limpiarCupon();
        setModalIsOpen(false);
        setModalIsOpen2(false);
    };



    // Función para aumentar la cantidad de un producto en el carrito
    const increaseQuantity = (index) => {
        const updatedCartItems = [...cartItems];
        updatedCartItems[index].cantidad += 1;
        setCartItems(updatedCartItems);
        localStorage.setItem('cart', JSON.stringify(updatedCartItems));
        
        // Revalidar cupón si está aplicado
        revalidarCuponSiAplicado(updatedCartItems);
    };

    // Función para disminuir la cantidad de un producto en el carrito
    const decreaseQuantity = (index) => {
        const updatedCartItems = [...cartItems];
        if (updatedCartItems[index].cantidad > 1) {
            updatedCartItems[index].cantidad -= 1;
            setCartItems(updatedCartItems);
            localStorage.setItem('cart', JSON.stringify(updatedCartItems));
            
            // Revalidar cupón si está aplicado
            revalidarCuponSiAplicado(updatedCartItems);
        }
    };


    //pedido-------------------------------------------------------------------
    const [mensaje, setMensaje] = useState('');
        const crearPedido = async () => {
        // ⛔ Validación de horarios solo cuando NO es reserva
        if (!estadoAbierto && deliveryOption !== "reserve") {
            const formatearHora = (hora) => hora ? hora.substring(0, 5) : "";
            let mensajeHorario = "El hotel está cerrado en este momento.";

            if (horarioHoy?.apertura1) {
                mensajeHorario += `\n\nHorarios de hoy:\n${formatearHora(horarioHoy.apertura1)} - ${formatearHora(horarioHoy.cierre1)}`;
                if (horarioHoy.apertura2) {
                    mensajeHorario += `\n${formatearHora(horarioHoy.apertura2)} - ${formatearHora(horarioHoy.cierre2)}`;
                }
            } else {
                mensajeHorario += "\n\nHoy estamos cerrados.";
            }

            Swal.fire({
                icon: "error",
                title: "Hotel cerrado",
                text: mensajeHorario,
                confirmButtonColor: "#00b7ff"
            });
            return;
        }

        // 🔒 Validar comprobante
        if (selectedPaymentMethod?.requires_proof == 1 && !paymentProof) {
            Swal.fire({
                icon: "error",
                title: "Comprobante requerido",
                text: "Este método de pago requiere que subas un comprobante",
                confirmButtonColor: "#00b7ff"
            });
            return;
        }

        // 🧱 Validar tamaño archivo
        if (paymentProof && paymentProof.size > 5 * 1024 * 1024) {
            toast.error("El archivo es demasiado grande. Máximo 5MB");
            return;
        }
        if(name.trim() == ''){
            toast.error("El nombre es obligatorio.");
            return;
        }
        setMensaje("Procesando...");

        try {
            // ======================================================
            //   🔥 CONSTRUCCIÓN DE PRODUCTOS (NORMAL + RESERVA)
            // ======================================================
            const productosPedido = cartItems.map(item => {
                // Si es reserva
                if (esReserva(item)) {
                    return {
                        tipo: "reserva",
                        idProducto: item.idProducto,
                        fecha_inicio: item.fecha_inicio,
                        fecha_fin: item.fecha_fin,
                        noches: item.noches,
                        total: item.total,
                        detalle: item.detalle,   // array con precios por noche
                        cantidad: 1,
                        titulo: item.titulo || "Reserva",
                        items: [],
                        precio: item.total,
                        imagen: obtenerImagen(item)
                    };
                }

                // Producto normal
                let itemPrice = item.precio;
                if (Array.isArray(item.items)) {
                    item.items.forEach(ad => {
                        if (ad.price) itemPrice += Number(ad.price);
                    });
                }

                return {
                    tipo: "producto",
                    idProducto: item.idProducto,
                    titulo: item.titulo,
                    cantidad: item.cantidad,
                    items: item.items || item.item,
                    precio: itemPrice,
                    imagen: obtenerImagen(item)
                };
            });
            const productosPedidoJSON = JSON.stringify(productosPedido);

            // ============================
            //   💰 TOTAL GENERAL
            // ============================
            let totalPrice = 0;

            cartItems.forEach(item => {
                if (esReserva(item)) {
                    totalPrice += item.total;
                } else {
                    let p = item.precio;
                    if (Array.isArray(item.items)) {
                        item.items.forEach(ad => {
                            if (ad.price) p += Number(ad.price);
                        });
                    }
                    totalPrice += p * item.cantidad;
                }
            });

            const totalPriceWithDiscount = Math.max(0, totalPrice - descuento);

            // ====================================
            //   📦 Armado de FormData para enviar
            // ====================================
            const formData = new FormData();
            if(productosPedido[0].fecha_inicio){
                formData.append("startDate", productosPedido[0].fecha_inicio);
            }
            if(productosPedido[0].fecha_fin){
                formData.append("finishDate", productosPedido[0].fecha_fin);
            }
            formData.append("productos", productosPedidoJSON);
            formData.append("total", totalPriceWithDiscount);
            formData.append("nombre", name);
            formData.append("telefono", telefono);
            formData.append("nota", noteText);
            formData.append("codigo", codigo);
            formData.append("cupon_id", cuponAplicado ? cuponAplicado.idCodigo : "");
            formData.append("descuento_aplicado", descuento);
            formData.append("estado", "Pendiente");
            formData.append("pago", selectedPaymentMethod?.name || 'Efectivo');
            formData.append("payment_method_id", selectedPaymentMethod?.idPaymentMethod || "");
            formData.append("payment_reference", paymentReference);
            if (paymentProof) {
                formData.append("payment_proof", paymentProof);
            }

            // Forma de entrega
            let entrega = "";
            const mesa = mesasDisponibles.find(m => m.idMesa === parseInt(mesaSeleccionada));
            if (deliveryOption === "mesa") {
                entrega = `Comer en la acomodación - Acomodación ${mesa ? mesa.numero : mesaSeleccionada}`;
            } else if (deliveryOption === "reserve") {
                entrega = `Reserva en Acomodación`;
            } else {
                entrega = `Retirar personalmente - Acomodación ${mesa ? mesa.numero : mesaSeleccionada}`;
            }

            formData.append("entrega", entrega);

            if (mesaSeleccionada) {
                formData.append("idMesa", mesaSeleccionada);
            }
            // ------------------------
            //  📡 Enviar al backend
            // ------------------------
            const response = await fetch(`${baseURL}/pedidoPostWithPayment.php`, {
                method: "POST",
                body: formData
            });

            const data = await response.json();

            if (data.mensaje) {
                // Guardar idPedido antes de limpiar
                const pedidoId = data.idPedido;
                const nombrePedido = name;
                const telefonoPedido = telefono;

                Swal.fire("Pedido enviado!", data.mensaje, "success");

                // Registrar cupón
                if (cuponAplicado && descuento > 0 && pedidoId) {
                    await fetch(`${baseURL}/codigosAplicar.php`, {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({
                            cupon_id: cuponAplicado.idCodigo,
                            pedido_id: pedidoId,
                            monto_descuento: descuento
                        })
                    });
                }

                // Limpiar
                setName("");
                limpiarCupon();
                setNoteText("");
                closeModal();
                closeModal2();
                clearCart();

                // Mandar mensaje WhatsApp
                handleWhatsappMessage();
                // Mostrar modal de evaluación si está activada y el pedido no ha sido evaluado
                if (configuracion.evaluacion_activo && pedidoId) {
                    // Verificar si ya fue evaluado
                    const yaEvaluado = await verificarEvaluacionPedido(pedidoId);
                    const evaluadoLocalmente = pedidosEvaluados.includes(pedidoId);
                    
                    if (!yaEvaluado && !evaluadoLocalmente) {
                        setTimeout(() => {
                            setUltimoPedidoId(pedidoId);
                            setName(nombrePedido);
                            setTelefono(telefonoPedido);
                            setFeedbackModalOpen(true);
                        }, 1500);
                    }
                }

            } else if (data?.error) {
                Swal.fire("Error", data.error, "error");
            }

        } catch (error) {
            console.error("Error:", error);
            Swal.fire("Error", "Error de conexión. Intenta nuevamente.", "error");
        }
    };

    const cerrarFeedbackModal = () => {
        setFeedbackModalOpen(false);
        // Marcar como evaluado localmente para esta sesión
        if (ultimoPedidoId) {
            setPedidosEvaluados([...pedidosEvaluados, ultimoPedidoId]);
        }
    };

    const esReserva = (item) => item.fecha_inicio && item.fecha_fin;
    const formatearFecha = (fechaStr) => {
        const d = new Date(fechaStr + "T00:00:00");
        return d.toLocaleDateString("es-AR", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric"
        });
    };


    return (
        <div>
            <ToastContainer />
            
            {/* Modal de Evaluación */}
            <FeedbackModal
                isOpen={feedbackModalOpen}
                onClose={cerrarFeedbackModal}
                pedidoId={ultimoPedidoId}
                nombreCliente={name}
                telefonoCliente={telefono}
            />

            <button onClick={openModal} className='cartIconFixed'>
                {
                    cartItems?.length >= 1 && (
                        <span>{cartItems.length}</span>
                    )

                }
                <FontAwesomeIcon icon={faShoppingCart} />
            </button>

            <Modal
                isOpen={modalIsOpen}
                className="modal-cart"
                overlayClassName="overlay-cart"
                onRequestClose={closeModal}
            >
                <div className='deFLex'>
                    <button onClick={closeModal} ><FontAwesomeIcon icon={faArrowLeft} />  </button>
                    <button onClick={clearCart} className='deleteToCart'>Vaciar carrito</button>
                </div>
                {cartItems?.length === 0 ?
                    (<p className='nohay'> No hay productos</p>)
                    : (<div  className="oha">
                        <div className="modal-content-cart">


                            {loading ? (
                                <p>Cargando...</p>
                            ) : (
                                <div>

                                    {cartItems.map((item, index) => {
                                        const reserva = esReserva(item);
                                        return (
                                            <div key={index} className='cart-item'>
                                                {reserva ? (
                                                    <div className="reserva-card">

                                                        <div className="reserva-title">
                                                            🏨 {item.titulo}
                                                        </div>

                                                        <div className="reserva-info">
                                                            <div>
                                                                <span>Entrada:</span>
                                                                <strong>{item.fecha_inicio}</strong>
                                                            </div>
                                                            <div>
                                                                <span>Salida:</span>
                                                                <strong>{item.fecha_fin}</strong>
                                                            </div>
                                                            <div>
                                                                <span>Noches:</span>
                                                                <strong>{item.noches}</strong>
                                                            </div>
                                                            <div className="reserva-total">
                                                                <span>Total reserva:</span>
                                                                <strong>${item.total.toLocaleString("es-AR")}</strong>
                                                            </div>
                                                        </div>
                                                        <button onClick={() => removeFromCart(item.idProducto)} className='deleteCart deleteReserve'>  <FontAwesomeIcon icon={faTrash} /></button>
                                                    </div>
                                                ) : (
                                                    /* ---- PRODUCTO NORMAL ---- */
                                                    <div className='cart-text-box'>
                                                        <p>{item.titulo}</p>
                                                    </div>
                                                )}

                                                {/* Ocultar botones + / - si es reserva */}
                                                {!reserva && (
                                                    <div className='deColumn'>
                                                        <button onClick={() => removeFromCart(item.idProducto)} className='deleteCart'>  <FontAwesomeIcon icon={faTrash} /></button>
                                                        <div className='deFlexCantidad'>
                                                            <button onClick={() => decreaseQuantity(index)}>-</button>
                                                            <span>{item.cantidad}</span>
                                                            <button onClick={() => increaseQuantity(index)}>+</button>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    })}

                                </div>
                            )}
                        </div>
                        <div className='deColumnCart'>
                            {descuento > 0 && codigoValido ? (
                                <div className='resumen-precios'>
                                    <div className='precio-linea'>
                                        <span>Subtotal:</span>
                                        <span>{moneda} {totalPrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</span>
                                    </div>
                                    <div className='precio-linea descuento-linea'>
                                        <span>Descuento:</span>
                                        <span>-{moneda} {descuento.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</span>
                                    </div>
                                    <div className='precio-linea total-linea'>
                                        <strong>Total:</strong>
                                        <strong>{moneda} {(totalPrice - descuento).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</strong>
                                    </div>
                                </div>
                            ) : (
                                <h4>Total: {moneda} {totalPrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</h4>
                            )}

                            <div className='deFLexBtns'>

                                <button className='btnWpp' onClick={openModal2}>
                                    Pedir por WhatsApp <img src={whatsappIcon} alt="WhatsApp" />
                                </button>

                            </div>
                        </div>

                        <Modal
                            isOpen={modalIsOpen2}
                            onRequestClose={closeModal2}
                            className="modal-cart"
                            overlayClassName="overlay-cart"
                        >
                            <div className='deFLex'>
                                <button onClick={closeModal2} ><FontAwesomeIcon icon={faArrowLeft} />  </button>
                                <h4>Agregar Detalles</h4>
                            </div>
                            <div className="modal-send-form">
                                <input
                                    type="text"
                                    id="name"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    placeholder='Nombre (obligatorio)'
                                />
                                <input
                                    type="number"
                                    id="telefono"
                                    value={telefono}
                                    onChange={(e) => setTelefono(e.target.value)}
                                    placeholder='Teléfono'
                                />
                                <div className='deFLexRadio'>
                                    <label>Opciones de entrega</label>

                                    <div
                                        onClick={() => setDeliveryOption('reserve')}
                                    >
                                        <input
                                            type="radio"
                                            id="reserve"
                                            name="deliveryOption"
                                            value="reserve"
                                            checked={deliveryOption === 'reserve'}
                                            onChange={() => setDeliveryOption('reserve')}
                                        />
                                        <label htmlFor="reserve">Reservación de acomodación</label>
                                    </div>
                                    
                                    {configuracion.retiro_activo === 1 && (
                                        <div
                                            onClick={() => setDeliveryOption('pickup')}
                                        >
                                            <input
                                                type="radio"
                                                id="pickup"
                                                name="deliveryOption"
                                                value="pickup"
                                                checked={deliveryOption === 'pickup'}
                                                onChange={() => setDeliveryOption('pickup')}
                                            />
                                            <label htmlFor="pickup">Retirar personalmente</label>
                                        </div>
                                    )}

                                    {configuracion.mesa_activo === 1 && (
                                        <div
                                            onClick={() => setDeliveryOption('mesa')}
                                        >
                                            <input
                                                type="radio"
                                                id="mesa"
                                                name="deliveryOption"
                                                value="mesa"
                                                checked={deliveryOption === 'mesa'}
                                                onChange={() => setDeliveryOption('mesa')}
                                            />
                                            <label htmlFor="mesa">Comer en la acomodación</label>
                                        </div>
                                    )}

                                </div>
                                {(deliveryOption === 'mesa' || deliveryOption === "pickup") && (
                                    <div className='mesaSelectContainer'>
                                        <label>Seleccione una Acomodación</label>
                                        <select
                                            value={mesaSeleccionada}
                                            onChange={(e) => setMesaSeleccionada(e.target.value)}
                                            className='selectMesa'
                                            required
                                        >
                                            <option value=''>Seleccione una acomodación</option>
                                            {mesasDisponibles && mesasDisponibles.length > 0 ? (
                                                mesasDisponibles.map((mesa) => (
                                                    <option key={mesa.idMesa} value={mesa.idMesa}>
                                                        {mesa.numero} 
                                                    </option>
                                                ))
                                            ) : (
                                                <option value='' disabled>No hay acomodaciones disponibles</option>
                                            )}
                                        </select>
                                        {mesasDisponibles.length === 0 && (
                                            <p className='mesaWarning'>Todas las acomodaciones están ocupadas actualmente</p>
                                        )}
                                    </div>
                                )}
                                <div className='deFLexRadio'>
                                    <label>Formas de pago</label>
                                    {paymentMethods.map((method) => (
                                        <div key={method.idPaymentMethod} onClick={() => setSelectedPaymentMethod(method)}>
                                            <input
                                                type="radio"
                                                id={`payment_${method.idPaymentMethod}`}
                                                name="paymentMethod"
                                                value={method.idPaymentMethod}
                                                checked={selectedPaymentMethod?.idPaymentMethod === method.idPaymentMethod}
                                                onChange={() => setSelectedPaymentMethod(method)}
                                            />
                                            <label htmlFor={`payment_${method.idPaymentMethod}`}>{method.name}</label>
                                        </div>
                                    ))}
                                </div>
                                
                                {/* Instrucciones del método de pago seleccionado */}
                                {selectedPaymentMethod && (selectedPaymentMethod.image_path || selectedPaymentMethod.instructions) && (
                                    <div className='paymentInstructions'>
                                        <label>Instrucciones de pago</label>
                                        
                                        {/* Mostrar imagen si existe */}
                                        {selectedPaymentMethod.image_path && (
                                            <div className='paymentImageContainer'>
                                                <img 
                                                    src={`${baseURL}/${selectedPaymentMethod.image_path}`} 
                                                    alt='Instrucciones de pago'
                                                    className='paymentImage'
                                                />
                                            </div>
                                        )}
                                        
                                        {/* Mostrar instrucciones HTML si existen */}
                                        {selectedPaymentMethod.instructions && (
                                            <div 
                                                className='instructionsContent'
                                                dangerouslySetInnerHTML={{ 
                                                    __html: DOMPurify.sanitize(selectedPaymentMethod.instructions, {
                                                        ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'u', 'h1', 'h2', 'h3', 'h4', 'ul', 'ol', 'li', 'img'],
                                                        ALLOWED_ATTR: ['src', 'alt', 'style', 'class']
                                                    }) 
                                                }}
                                            />
                                        )}
                                    </div>
                                )}
                                
                                {/* Referencia de pago (opcional, excepto para Efectivo) */}
                                {selectedPaymentMethod && selectedPaymentMethod.name !== 'Efectivo' && (
                                    <div className='paymentReferenceContainer'>
                                        <input
                                            type="text"
                                            id="paymentReference"
                                            value={paymentReference}
                                            onChange={(e) => setPaymentReference(e.target.value)}
                                            placeholder='Referencia de pago (opcional)'
                                        />
                                    </div>
                                )}
                                
                                {/* Comprobante de pago (si es requerido) */}
                                {selectedPaymentMethod && selectedPaymentMethod.requires_proof == 1 && (
                                    <div className='paymentProofContainer'>
                                        <label htmlFor="paymentProof">
                                            Comprobante de pago <span className='required'>*</span>
                                        </label>
                                        <input
                                            type="file"
                                            id="paymentProof"
                                            accept="image/*,application/pdf"
                                            onChange={handlePaymentProofChange}
                                        />
                                        {paymentProofPreview && (
                                            <div className='proofPreview'>
                                                <img src={paymentProofPreview} alt="Vista previa" />
                                            </div>
                                        )}
                                        {paymentProof && !paymentProofPreview && (
                                            <p className='fileSelected'>Archivo seleccionado: {paymentProof.name}</p>
                                        )}
                                    </div>
                                )}

                                
                                {/* Sección de cupón */}
                                <div className='cupon-container'>
                                    <div className='cupon-input-group'>
                                        <input
                                            type="text"
                                            id="codigo"
                                            value={codigo}
                                            onChange={(e) => {
                                                setCodigo(e.target.value.toUpperCase());
                                                if (codigoValido) {
                                                    limpiarCupon();
                                                }
                                            }}
                                            placeholder='Código de cupón (opcional)'
                                            disabled={codigoValido}
                                        />
                                        {!codigoValido ? (
                                            <button 
                                                type='button' 
                                                className='btn-aplicar-cupon'
                                                onClick={validarCupon}
                                                disabled={!codigo.trim() || validandoCupon}
                                            >
                                                {validandoCupon ? 'Validando...' : 'Aplicar'}
                                            </button>
                                        ) : (
                                            <button 
                                                type='button' 
                                                className='btn-quitar-cupon'
                                                onClick={limpiarCupon}
                                            >
                                                Quitar
                                            </button>
                                        )}
                                    </div>
                                    
                                    {codigoValido && cuponAplicado && (
                                        <div className='cupon-aplicado-info'>
                                            <p className='cupon-aplicado-mensaje'>
                                                ✓ Cupón aplicado: <strong>{cuponAplicado.codigo}</strong>
                                            </p>
                                            <p className='cupon-aplicado-descripcion'>
                                                {cuponAplicado.descripcion}
                                            </p>
                                            <p className='cupon-descuento'>
                                                Descuento: <strong style={{color: '#4CAF50'}}>
                                                    {moneda} {descuento.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                                                </strong>
                                            </p>
                                        </div>
                                    )}
                                </div>
                                <textarea
                                    placeholder="Agrega una nota (opcional)"
                                    value={noteText}
                                    onChange={(e) => setNoteText(e.target.value)}
                                />
                                <fieldset className='deNonefieldset'>
                                    <legend>Productos</legend>
                                    <textarea
                                        name='productos'
                                        value={cartItems.map(item => {
                                            const adicionalesText = Array.isArray(item.items) 
                                                ? item.items.map(a => a.name || a).join(', ')
                                                : Array.isArray(item.item) 
                                                    ? item.item.join(', ')
                                                    : '';
                                            return `${item.titulo}, x ${item.cantidad}, ${adicionalesText},${item.categoria},${item.precio}, ${obtenerImagen(item)}`;
                                        }).join('\n')}
                                        readOnly
                                    />
                                </fieldset>


                            </div>
                            {mensaje ? (
                                <button type='button' className='btn' disabled>
                                    {mensaje}
                                </button>
                            ) : (
                                <button type='button' onClick={crearPedido} className='btn'>
                                    Finalizar pedido
                                </button>
                            )}
                        </Modal>

                    </div>)}

            </Modal>
        </div >
    );
});

export default Cart;
